import { h, render, Component } from 'preact';
import { appConfig } from '../app.config';
import TxrDropdownHover from './txr-dropdown-hover';
import TxrDropdownMenu from './txr-dropdown-menu';
import TxrCheckbox from './txr-checkbox';
import axios from 'axios';

class TxrResourcesHub extends Component {
    state = {
        isLoading: false,
        isError: false,
        singleModeType: undefined,
        topics: [
            { title: '— View all —', id: '' },
            { title: 'COMMUNICATIONS', id: 'COMMUNICATIONS', link: 'communications' },
            { title: 'CUSTOMER SERVICE', id: 'CUSTOMER SERVICE', link: 'customer-service' },
            { title: 'HR', id: 'HR', link: 'hr' },
            { title: 'MARKETING', id: 'MARKETING', link: 'marketing' },
            { title: 'SALES', id: 'SALES', link: 'sales' }
        ],
        industries: [
            { title: '— View all —', id: '' },
            { title: 'FRANCHISES', id: 'FRANCHISES', link: 'franchises' },
            { title: 'HVAC', id: 'HVAC', link: 'hvac' },
            { title: 'INSURANCE', id: 'INSURANCE', link: 'insurance' },
            { title: 'NON-PROFIT', id: 'NON-PROFIT', link: 'non-profit' },
            { title: 'GENERAL', id: 'GENERAL', link: 'general' }
        ],
        industryModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                // this.forceUpdate();
            }
        },
        topicsModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                // this.forceUpdate();
            }
        },
        types: {
            allTypes: true,
            caseStudies: false,
            insights: false,
            messageTemplates: false,
            eBooks: false,
            playbooks: false,
            newsletters: false
        },
        isFiltered: false,
        caseStudies: [],
        insights: [],
        messageTemplates: [],
        eBooks: [],
        playbooks: [],
        helpCenters: [],
        newsletters: []
    }
    componentDidMount() {
        window.onpopstate = (e) => {
            this.restoreState();
        }
        this.restoreState();
    }
    restoreState = () => {
        const index = window.location.href.indexOf('?');
        if (index == -1) {
            this.url = window.location.href;
        } else {
            this.url = window.location.href.substring(0, index);
        }
        this.state.types.allTypes = true;
        const index1 = this.url.lastIndexOf('/') + 1;
        if (index1 > 0) {
            const type = this.url.substring(index1).toLowerCase();
            if (!!type && type !== 'resources' && type !== 'all') {
                if (type === 'case-studies') {
                    this.state.types.allTypes = false;
                    this.state.types.caseStudies = true;
                    this.viewInSingleMode('CaseStudy', 0);
                }
                if (type === 'insights') {
                    this.state.types.allTypes = false;
                    this.state.types.insights = true;
                    this.viewInSingleMode('Insight', 0);
                }
                if (type === 'message-templates') {
                    this.state.types.allTypes = false;
                    this.state.types.messageTemplates = true;
                    this.viewInSingleMode('MessageTemplate', 0);
                }
                if (type === 'ebooks') {
                    this.state.types.allTypes = false;
                    this.state.types.eBooks = true;
                    this.viewInSingleMode('eBook', 0);
                }
                if (type === 'playbooks') {
                    this.state.types.allTypes = false;
                    this.viewInSingleMode('Playbook', 0);
                    this.state.types.playbooks = true;
                }
                if (type === 'newsletters') {
                    this.state.types.allTypes = false;
                    this.viewInSingleMode('Newsletter', 0);
                    this.state.types.newsletters = true;
                }
                if(this.state.types.allTypes) {
                    const industry = this.state.industries.find(t => t.link === type);
                    if(!!industry) {
                        this.state.industryModel.value = industry;
                    } else {
                        const topic = this.state.topics.find(t => t.link === type);
                        if(!!topic) {
                        this.state.topicsModel.value = topic;
                        }
                    }
                }
            }
        }
        /*
        var hashes = window.location.href.slice(index + 1).split('&');

        for (var i = 0; i < hashes.length; i++) {
            let hash = hashes[i].split('=');
            if (hash[0] === 'content_type') {
                this.state.types.allTypes = false;
                const type = hash[1].toLowerCase();
                if(type==='casestudies') {
                    this.state.types.caseStudies = true;
                    this.viewInSingleMode('CaseStudy', 0);
                    break;
                }
                if(type==='insights') {
                    this.state.types.insights = true;
                    this.viewInSingleMode('Insight', 0);
                    break;
                }
                if(type==='messagetemplates') {
                    this.state.types.messageTemplates = true;
                    this.viewInSingleMode('MessageTemplate', 0);
                    break;
                }
                if(type==='ebooks') {
                    this.state.types.eBooks = true;
                    this.viewInSingleMode('eBook', 0);
                    break;
                }
                if(type==='playbooks') {
                    this.viewInSingleMode('Playbook', 0);
                    this.state.types.caseSplaybookstudies = true;
                    break;
                }
            }
        }*/
        if (this.state.types.allTypes) {
            this.submit();
        }

    }
    getLabel() {
        let str = 'Show Content Type: ';
        if (this.state.types.allTypes) {
            return `${str}All`;
        }
        if (this.state.types.caseStudies) {
            str = `${str}Case Studies, `;
        }
        if (this.state.types.insights) {
            str = `${str}Insights, `;
        }
        if (this.state.types.messageTemplates) {
            str = `${str}Message Templates, `;
        }
        if (this.state.types.eBooks) {
            str = `${str}eBooks & Reports, `;
        }
        if (this.state.types.playbooks) {
            str = `${str}Playbooks, `;
        }
        if (this.state.types.newsletters) {
            str = `${str}Newsletters, `;
        }        
        return str.slice(0, str.lastIndexOf(','));
    }
    filterAndSplit(arr, typeFilter) {
        const res = [];
        const array = arr.filter(d => d.type == typeFilter)
        var i, j, temporary, chunk = 3;
        for (i = 0, j = array.length; i < j; i += chunk) {
            temporary = array.slice(i, i + chunk);
            res.push(temporary);
        }
        return res;
    }
    toggleAll() {

        const state = this.state.types;
        // state[type] = !state[type];
        if (state.allTypes) {
            state.caseStudies = false;
            state.insights = false;
            state.messageTemplates = false;
            state.eBooks = false;
            state.playbooks = false;
            state.newsletters = false;
            this.setState(state);
        }
        this.setState({singleModeType: false});
        this.submit();
    }

    toggleType(type) {
        const state = this.state.types;
        // state[type] = !state[type];
        if (state[type]) {
            state.allTypes = false;
            this.setState(state);
        }
        let count = 0;
        for (let prop in state) {
            if (Object.prototype.hasOwnProperty.call(state, prop) && state[prop] === true) {
                count++;
            }
        }
        if(count > 1) {
            this.setState({singleModeType: false});
        }
        if (!state.caseStudies &&
            !state.insights &&
            !state.messageTemplates &&
            !state.eBooks &&
            !state.playbooks &&
            !state.newsletters
            ) {
            state.allTypes = true;
            this.setState({singleModeType: false});
            this.setState(state);
        }
        this.submit();
    }
    createFilterUrl() {
        this.state.isFiltered = false;
        let paramsStr = '';

        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
          });

        if(params.previewMode) {
            paramsStr = `${paramsStr}previewMode=${params.previewMode}&`;
        }
        if (this.state.industryModel && this.state.industryModel.value) {
            paramsStr = `${paramsStr}industry=${this.state.industryModel.value.id}&`;
            this.state.isFiltered = true;
        }
        if (this.state.topicsModel && this.state.topicsModel.value) {
            paramsStr = `${paramsStr}topic=${this.state.topicsModel.value.id}&`;
            this.state.isFiltered = true;
        }
        return paramsStr;

    }

    createRequest(paramsStr) {
        paramsStr = paramsStr.slice(0, paramsStr.lastIndexOf('&'));
        this.setState({ isLoading: true, isError: false });
        let url = `/resources/filter`;
        if (paramsStr) {
            url = `${url}?${paramsStr}`
        }
        const options = {
            method: 'GET',
            // headers: { 'content-type': 'application/x-www-form-urlencoded' },
            url
        };
        return axios(options)
            .then((response) => {
                this.setState({ isLoading: false, isError: false });
                return response;
            })
            .catch(() => {
                this.setState({ isLoading: false, isError: true });
                this.forceUpdate();
            });
    }

    singleModeAllIndustries() {
        this.state.industryModel.value = undefined;
        this.viewInSingleMode(this.state.singleModeType);
    }
    singleModeAllTopics() {
        this.state.topicsModel.value = undefined;
        this.viewInSingleMode(this.state.singleModeType);
    }
    viewInSingleMode(type, min) {
        if (min === undefined) {
            min = 0;
        }
        let paramsStr = this.createFilterUrl();
        this.state.isFiltered = true;
        paramsStr = `${paramsStr}types=${type}&maxCount=100&`;
        this.createRequest(paramsStr)
            .then((response) => {
                if (response.data && response.data.filter) {
                    if (response.data.length > min || !!this.state.singleModeType) {
                        if (type !== 'CaseStudy') {
                            this.setState({ caseStudies: null });
                        } else {
                            this.state.types.allTypes = false;
                            this.state.types.caseStudies = true;
                            this.state.types.insights = false;
                            this.state.types.messageTemplates = false;
                            this.state.types.eBooks = false;
                            this.state.types.playbooks = false;
                            this.state.types.newsletters = false;
                            this.setState({ caseStudies: this.filterAndSplit(response.data, type) });
                        }
                        if (type !== 'Insight') {
                            this.setState({ insights: null });
                        } else {
                            this.state.types.allTypes = false;
                            this.state.types.insights = true;
                            this.state.types.caseStudies = false;
                            this.state.types.messageTemplates = false;
                            this.state.types.eBooks = false;
                            this.state.types.playbooks = false;
                            this.state.types.newsletters = false;
                            this.setState({ insights: this.filterAndSplit(response.data, type) });
                        }
                        if (type !== 'MessageTemplate') {
                            this.setState({ messageTemplates: null });
                        } else {
                            this.state.types.allTypes = false;
                            this.state.types.messageTemplates = true;
                            this.state.types.caseStudies = false;
                            this.state.types.insights = false;
                            this.state.types.eBooks = false;
                            this.state.types.playbooks = false;
                            this.state.types.newsletters = false;
                            this.setState({ messageTemplates: this.filterAndSplit(response.data, type) });
                        }
                        if (type !== 'eBook') {
                            this.setState({ eBooks: null });
                        } else {
                            this.state.types.allTypes = false;
                            this.state.types.eBooks = true;
                            this.state.types.caseStudies = false;
                            this.state.types.insights = false;
                            this.state.types.messageTemplates = false;
                            this.state.types.playbooks = false;
                            this.state.types.newsletters = false;
                            this.setState({ eBooks: this.filterAndSplit(response.data, type) });
                        }
                        if (type !== 'Playbook') {
                            this.setState({ playbooks: null });
                        } else {
                            this.state.types.allTypes = false;
                            this.state.types.playbooks = true;
                            this.state.types.caseStudies = false;
                            this.state.types.insights = false;
                            this.state.types.messageTemplates = false;
                            this.state.types.eBooks = false;
                            this.state.types.newsletters = false;
                            this.setState({ playbooks: this.filterAndSplit(response.data, type) });
                        }
                        if (type !== 'Newsletter') {
                            this.setState({ newsletters: null });
                        } else {
                            this.state.types.allTypes = false;
                            this.state.types.newsletters = true;
                            this.state.types.caseStudies = false;
                            this.state.types.insights = false;
                            this.state.types.messageTemplates = false;
                            this.state.types.eBooks = false;
                            this.state.types.playbooks = false;
                            this.setState({ newsletters: this.filterAndSplit(response.data, type) });
                        }                        
                        this.setState({ singleModeType: type });
                        window.scrollTo(0, 0);
                    }
                }
            });
    }
    escapeSingleMode() {
        this.setState({ singleModeType: undefined });
        this.submit();
    }
    submit() {
        let filterCount = 0;
        let paramsStr = this.createFilterUrl();
        if (this.state.types.caseStudies) {
            paramsStr = `${paramsStr}types=CaseStudy&`;
            this.state.isFiltered = true;
            filterCount++;
        }
        if (this.state.types.insights) {
            paramsStr = `${paramsStr}types=Insight&`;
            this.state.isFiltered = true;
            filterCount++;
        }
        if (this.state.types.messageTemplates) {
            paramsStr = `${paramsStr}types=MessageTemplate&`;
            this.state.isFiltered = true;
            filterCount++;
        }
        if (this.state.types.eBooks) {
            paramsStr = `${paramsStr}types=eBook&`;
            this.state.isFiltered = true;
            filterCount++;
        }
        if (this.state.types.playbooks) {
            paramsStr = `${paramsStr}types=Playbook&`;
            this.state.isFiltered = true;
            filterCount++;
        }
        if (this.state.types.newsletters) {
            paramsStr = `${paramsStr}types=Newsletter&`;
            this.state.isFiltered = true;
            filterCount++;
        }        
        if(filterCount > 1 || this.state.types.allTypes) {
            paramsStr = `${paramsStr}maxCount=3&`;
        } else {
            paramsStr = `${paramsStr}maxCount=30&`;
        }
        this.createRequest(paramsStr)
            .then((response) => {
                if (response.data && response.data.filter) {
                    this.setState({ caseStudies: this.filterAndSplit(response.data, 'CaseStudy') });
                    this.setState({ insights: this.filterAndSplit(response.data, 'Insight') });
                    this.setState({ messageTemplates: this.filterAndSplit(response.data, 'MessageTemplate') });
                    this.setState({ eBooks: this.filterAndSplit(response.data, 'eBook') });
                    this.setState({ playbooks: this.filterAndSplit(response.data, 'Playbook') });
                    this.setState({ helpCenters: this.filterAndSplit(response.data, 'HelpCenter') });
                    this.setState({ newsletters: this.filterAndSplit(response.data, 'Newsletter') });

                }
                this.forceUpdate();
            });
    }
    render() {
        return (
            <div class="txr-resources-hub">
                <div class="resources-hub__dropdowns">
                    <div class="resources-hub__dropdown">
                        <TxrDropdownHover model={this.state.industryModel} options={this.state.industries} label={'ALL INDUSTRIES'} header="INDUSTRY" mobileHeader="Browse by Industry:" select={() => this.submit()} ></TxrDropdownHover>
                    </div>

                    <div class="resources-hub__dropdown">
                        <TxrDropdownHover model={this.state.topicsModel} options={this.state.topics} label={'ALL TOPICS'} header="TOPIC" mobileHeader="Browse by Topics:" select={() => this.submit()} ></TxrDropdownHover>
                    </div>

                </div>
                <div class="resources-hub__content-filters">
                    <div class="content-filters__desktop">
                        <TxrCheckbox item={this.state.types} isCheckedField="allTypes" label="All Content Types" select={() => this.toggleAll()}></TxrCheckbox>
                        <span class="filter-space"></span>
                        <TxrCheckbox item={this.state.types} isCheckedField="caseStudies" label="Case Studies" select={() => this.toggleType('caseStudies')}></TxrCheckbox>
                        <TxrCheckbox item={this.state.types} isCheckedField="insights" label="Insights" select={() => this.toggleType('insights')}></TxrCheckbox>
                        <TxrCheckbox item={this.state.types} isCheckedField="messageTemplates" label="Message Templates" select={() => this.toggleType('messageTemplates')}></TxrCheckbox>
                        <TxrCheckbox item={this.state.types} isCheckedField="eBooks" label="eBooks & Reports" select={() => this.toggleType('eBooks')}></TxrCheckbox>
                        <TxrCheckbox item={this.state.types} isCheckedField="playbooks" label="Playbooks" select={() => this.toggleType('playbooks')}></TxrCheckbox>
                        <TxrCheckbox item={this.state.types} isCheckedField="newsletters" label="Newsletters" select={() => this.toggleType('newsletters')}></TxrCheckbox>
                    </div>
                    <div class="content-filters__mobile">
                        <TxrDropdownMenu class="content-filters__mobile" label={this.getLabel()} mobileHeader="Show Content Type:" content="<TxrResourcesHubMobileFilter/>" context={this.state.types} submit={() => this.submit()} ></TxrDropdownMenu>
                    </div>
                </div>

                <div class="resources-hub__content">
                    {
                        this.state.playbooks && this.state.playbooks.length > 0 &&
                        <div class="resources-hub__playbooks txr-section-iconed txr-recommended-section first-section" >
                            <div class="txr-section__header">
                                <div class="txr-section__header-icon">
                                    <img class="txr-section__header-icon-image" src="/images/resources-hub/icon-playbook.svg" alt="playbook"/>
                                </div>
                                <h3 class="txr-section__h5header txr-h txr-on-white">
                                    PLAYBOOKS
                                </h3>
                                <div class="txr-section__header-title txr-h">
                                    Industry-specific guides to texting
                                </div>
                            </div>
                            {
                                this.state.playbooks.map(row =>
                                    <div class="txr-section__items">
                                        {
                                            row.map(item =>
                                                <a class="txr-section__item txr-width30" href={item.linkUrl}>
                                                    {item.image &&
                                                        <div class="item-image-area">
                                                            <img class="item-image" src={(item.image ? item.image.file.url : '')} alt={(item.image ? item.image.description : '')}/>
                                                        </div>
                                                    }
                                                    <div class="item-header">
                                                        <img class="item-header__icon-image" src="/images/resources-hub/icon-sm-playbook.svg" alt="playbook"/>
                                                        <span class="item-header__line"></span>
                                                        <span class="item-header__text">{item.headerText}</span>
                                                    </div>
                                                    <h4 class="item-body">
                                                        {item.text}
                                                    </h4>
                                                    <div class="item-bottom">
                                                        <a class="txr-angle__link" href={item.linkUrl}>Read <i class="txr-angle__link-icon fal fa-angle-right"></i></a>
                                                        <span class="item-bottom__time">{item.minutesToRead} min read</span>
                                                    </div>
                                                </a>
                                            )
                                        }
                                    </div>
                                )}
                            {!this.state.singleModeType &&
                                <div class="txr-recommended-section__buttons">
                                    <button class="txr-button txr-action-button txr-black-text txr-width230" type="button" onClick={() => this.viewInSingleMode('Playbook')}>
                                        <span class="txr-button__content">VIEW ALL PLAYBOOKS<i class="txr-button__angle-icon fal fa-angle-right"></i></span>
                                    </button>
                                </div>
                            }
                        </div>
                    }
                    {
                        this.state.messageTemplates && this.state.messageTemplates.length > 0 &&
                        <div class={'resources-hub__message-templates txr-section-iconed txr-recommended-section' +
                            ((!this.state.playbooks || !this.state.playbooks.length) ? ' first-section' : '')}>
                            <div class="txr-section__header">
                                <div class="txr-section__header-icon">
                                    <i class="txr-section__header-icon-i fal fa-file-heart"></i>
                                </div>
                                <h3 class="txr-section__h5header txr-h txr-on-white">
                                    MESSAGE TEMPLATES
                                </h3>
                                <div class="txr-section__header-title txr-h">
                                    Proven examples to copy or riff on
                                </div>
                            </div>
                            {
                                this.state.messageTemplates.map(row =>
                                    <div class="txr-section__items">
                                        {
                                            row.map(item =>
                                                <a class="txr-section__item txr-width30" href={item.linkUrl}>
                                                    <div class="item-image-area">
                                                        <img class="item-image" src={(item.image ? item.image.file.url : '')} alt={(item.image ? item.image.description : '')}/>
                                                    </div>
                                                    <div class="item-header">
                                                        <i class="item-header__icon fal fa-file-heart"></i>
                                                        <span class="item-header__line"></span>
                                                        <span class="item-header__text">{item.headerText}</span>
                                                    </div>
                                                    <h4 class="item-body">
                                                        {item.text}
                                                    </h4>
                                                    <div class="item-bottom">
                                                        <a class="txr-angle__link" href={item.linkUrl}>Read <i class="txr-angle__link-icon fal fa-angle-right"></i></a>
                                                        <span class="item-bottom__time">{item.minutesToRead} min read</span>
                                                    </div>
                                                </a>
                                            )
                                        }
                                    </div>
                                )}
                            {!this.state.singleModeType &&
                                <div class="txr-recommended-section__buttons">
                                    <button class="txr-button txr-action-button txr-black-text txr-width230" type="button" onClick={() => this.viewInSingleMode('MessageTemplate')}>
                                        <span class="txr-button__content">VIEW ALL MESSAGE TEMPLATES<i class="txr-button__angle-icon fal fa-angle-right"></i></span>
                                    </button>
                                </div>
                            }
                        </div>
                    }
                    {
                        this.state.caseStudies && this.state.caseStudies.length > 0 &&
                        <div class={'resources-hub__casestudy txr-section-iconed txr-recommended-section' +
                            ((!this.state.playbooks || !this.state.playbooks.length)
                                && (!this.state.messageTemplates || !this.state.messageTemplates.length) ? ' first-section' : '')
                        }>
                            <div class="txr-section__header">
                                <div class="txr-section__header-icon">
                                    <img class="txr-section__header-icon-image width50" src="/images/resources-hub/icon-case-studies-new.svg" alt="case-study"/>
                                </div>
                                <h3 class="txr-section__h5header txr-h txr-on-white">
                                    CASE STUDIES
                                </h3>
                                <div class="txr-section__header-title txr-h">
                                    Success stories from real customers
                                </div>
                            </div>
                            {
                                this.state.caseStudies.map(row =>
                                    <div class="txr-section__items">
                                        {
                                            row.map(item =>
                                                <a class="txr-section__item case-study txr-width30" href={item.linkUrl}>
                                                    <div class="item-image-area">
                                                        <img class="item-image" src={(item.image ? item.image.file.url : '')} alt={(item.image ? item.image.description : '')}/>
                                                    </div>
                                                    <div class="item-header">
                                                        <img class="item-header__icon-image" src="/images/resources-hub/icon-case-studies-new-grey.svg" alt="case-study"/>
                                                        <span class="item-header__line"></span>
                                                        <span class="item-header__text">{item.headerText}</span>
                                                    </div>
                                                    <h4 class="item-body">
                                                        {item.text}
                                                    </h4>
                                                    <div class="item-bottom">
                                                        <a class="txr-angle__link" href={item.linkUrl}>Read <i class="txr-angle__link-icon fal fa-angle-right"></i></a>
                                                        <span class="item-bottom__time">{item.minutesToRead} min read</span>
                                                    </div>
                                                </a>
                                            )
                                        }
                                    </div>
                                )}
                            {!this.state.singleModeType &&
                                <div class="txr-recommended-section__buttons">
                                    <button class="txr-button txr-action-button txr-black-text txr-width230" type="button" onClick={() => this.viewInSingleMode('CaseStudy')}>
                                        <span class="txr-button__content">VIEW ALL CASE STUDIES<i class="txr-button__angle-icon fal fa-angle-right"></i></span>
                                    </button>
                                </div>
                            }
                        </div>
                    }
                    {
                        this.state.insights && this.state.insights.length > 0 &&
                        <div class={'resources-hub__insight txr-section-iconed txr-recommended-section' +
                            ((!this.state.playbooks || !this.state.playbooks.length)
                                && (!this.state.messageTemplates || !this.state.messageTemplates.length)
                                && (!this.state.caseStudies || !this.state.caseStudies.length) ? ' first-section' : '')}>
                            <div class="txr-section__header">
                                <div class="txr-section__header-icon">
                                    <img class="txr-section__header-icon-image width50" src="/images/resources-hub/icon-insights-new.svg" alt="insights"/>
                                </div>
                                <h3 class="txr-section__h5header txr-h txr-on-white">
                                    INSIGHTS
                                </h3>
                                <div class="txr-section__header-title txr-h">
                                    General tips to spark engagement
                                </div>
                            </div>
                            {
                                this.state.insights.map(row =>
                                    <div class="txr-section__items">
                                        {
                                            row.map(item =>
                                                <a class="txr-section__item txr-width30" href={item.linkUrl}>
                                                    <div class="item-image-area">
                                                        <img class="item-image" src={(item.image ? item.image.file.url : '')} alt={(item.image ? item.image.description : '')}/>
                                                    </div>
                                                    <div class="item-header">
                                                        <img class="item-header__icon-image" src="/images/resources-hub/icon-insights-new-grey.svg" alt="insights"/>
                                                        <span class="item-header__line"></span>
                                                        <span class="item-header__text">{item.headerText}</span>
                                                    </div>
                                                    <h4 class="item-body">
                                                        {item.text}
                                                    </h4>
                                                    <div class="item-bottom">
                                                        <a class="txr-angle__link" href={item.linkUrl}>Read <i class="txr-angle__link-icon fal fa-angle-right"></i></a>
                                                        <span class="item-bottom__time">{item.minutesToRead} min read</span>
                                                    </div>
                                                </a>
                                            )
                                        }
                                    </div>
                                )}
                            {!this.state.singleModeType &&
                                <div class="txr-recommended-section__buttons">
                                    <button class="txr-button txr-action-button txr-black-text txr-width230" type="button" onClick={() => this.viewInSingleMode('Insight')}>
                                        <span class="txr-button__content">VIEW ALL INSIGHTS<i class="txr-button__angle-icon fal fa-angle-right"></i></span>
                                    </button>
                                </div>
                            }
                        </div>
                    }
                    {
                        this.state.eBooks && this.state.eBooks.length > 0 &&
                        <div class={'resources-hub__ebooks txr-section-iconed txr-recommended-section' +
                            ((!this.state.playbooks || !this.state.playbooks.length)
                                && (!this.state.messageTemplates || !this.state.messageTemplates.length)
                                && (!this.state.caseStudies || !this.state.caseStudies.length)
                                && (!this.state.insights || !this.state.insights.length) ? ' first-section' : '')}>
                            <div class="txr-section__header">
                                <div class="txr-section__header-icon">
                                    <i class="txr-section__header-icon-i fal fa-book-heart"></i>
                                </div>
                                <h3 class="txr-section__h5header txr-h txr-on-white">
                                    EBOOKS + REPORTS
                                </h3>
                                <div class="txr-section__header-title txr-h">
                                    Downloadable expertise and data
                                </div>
                            </div>
                            {
                                this.state.eBooks.map(row =>
                                    <div class="txr-section__items">
                                        {
                                            row.map(item =>
                                                <a class="txr-section__item txr-width30" href={item.linkUrl}>
                                                    <div class="item-image-area">
                                                        <img class="item-image" src={(item.image ? item.image.file.url : '')} alt={(item.image ? item.image.description : '')}/>
                                                    </div>
                                                    <div class="item-header">
                                                        <i class="item-header__icon fal fa-book-heart"></i>
                                                        <span class="item-header__line"></span>
                                                        <span class="item-header__text">{item.headerText}</span>
                                                    </div>
                                                    <h4 class="item-body">
                                                        {item.text}
                                                    </h4>
                                                    <div class="item-bottom">
                                                        <a class="txr-angle__link" href={item.linkUrl}>Read <i class="txr-angle__link-icon fal fa-angle-right"></i></a>
                                                        <span class="item-bottom__time">{item.minutesToRead} min read</span>
                                                    </div>
                                                </a>
                                            )
                                        }
                                    </div>
                                )}
                            {!this.state.singleModeType &&
                                <div class="txr-recommended-section__buttons">
                                    <button class="txr-button txr-action-button txr-black-text txr-width230" type="button" onClick={() => this.viewInSingleMode('eBook')}>
                                        <span class="txr-button__content">VIEW ALL EBOOKS + REPORTS<i class="txr-button__angle-icon fal fa-angle-right"></i></span>
                                    </button>
                                </div>
                            }
                        </div>
                    }
                    {
                        this.state.newsletters && this.state.newsletters.length > 0 &&
                        <div class={'resources-hub__newsletters txr-section-iconed txr-recommended-section' +
                            ((!this.state.playbooks || !this.state.playbooks.length)
                                && (!this.state.messageTemplates || !this.state.messageTemplates.length)
                                && (!this.state.caseStudies || !this.state.caseStudies.length)
                                && (!this.state.insights || !this.state.insights.length) 
                                && (!this.state.eBooks || !this.state.insights.eBooks) 
                                ? ' first-section' : '')}>
                            <div class="txr-section__header">
                                <div class="txr-section__header-icon">
                                    <i class="txr-section__header-icon-i fal fa-pencil"></i>
                                </div>
                                <h3 class="txr-section__h5header txr-h txr-on-white">
                                    NEWSLETTERS
                                </h3>
                                <div class="txr-section__header-title txr-h">
                                    Mini-lessons to text like a pro
                                </div>
                            </div>
                            {
                                this.state.newsletters.map(row =>
                                    <div class="txr-section__items">
                                        {
                                            row.map(item =>
                                                <a class="txr-section__item txr-width30" href={item.linkUrl}>
                                                    <div class="item-image-area">
                                                        <img class="item-image" src={(item.image ? item.image.file.url : '')} alt={(item.image ? item.image.description : '')}/>
                                                    </div>
                                                    <div class="item-header">
                                                        <i class="item-header__icon fal fa-pencil"></i>
                                                        <span class="item-header__line"></span>
                                                        <span class="item-header__text">{item.headerText}</span>
                                                    </div>
                                                    <h4 class="item-body">
                                                        {item.text}
                                                    </h4>
                                                    <div class="item-bottom">
                                                        <a class="txr-angle__link" href={item.linkUrl}>Read <i class="txr-angle__link-icon fal fa-angle-right"></i></a>
                                                        <span class="item-bottom__time">{item.minutesToRead} min read</span>
                                                    </div>
                                                </a>
                                            )
                                        }
                                    </div>
                                )}
                            {!this.state.singleModeType &&
                                <div class="txr-recommended-section__buttons">
                                    <button class="txr-button txr-action-button txr-black-text txr-width230" type="button" onClick={() => this.viewInSingleMode('Newsletter')}>
                                        <span class="txr-button__content">VIEW ALL NEWSLETTERS<i class="txr-button__angle-icon fal fa-angle-right"></i></span>
                                    </button>
                                </div>
                            }
                        </div>
                    }                    
                    {
                        !this.state.isFiltered && !this.state.singleModeType && this.state.helpCenters && this.state.helpCenters.length > 0 &&
                        <div class={'resources-hub__help-centers txr-section-iconed txr-recommended-section' +
                            ((!this.state.playbooks || !this.state.playbooks.length)
                                && (!this.state.messageTemplates || !this.state.messageTemplates.length)
                                && (!this.state.caseStudies || !this.state.caseStudies.length)
                                && (!this.state.insights || !this.state.insights.length)
                                && (!this.state.eBooks || !this.state.eBooks.length)
                                && (!this.state.newsletters || !this.state.newsletters.length)
                                ? ' first-section' : '')}>
                            <div class="txr-section__header">
                                <div class="txr-section__header-icon">
                                    <i class="txr-section__header-icon-i fal fa-book-sparkles"></i>
                                </div>
                                <h3 class="txr-section__h5header txr-h txr-on-white">
                                    HELP CENTER
                                </h3>
                                <div class="txr-section__header-title txr-h">
                                    Our most used help docs
                                </div>
                            </div>
                            {
                                this.state.helpCenters.map(row =>
                                    <div class="txr-section__items">
                                        {
                                            row.map(item =>
                                                <a class="txr-section__item txr-width30" href={item.linkUrl}>
                                                    <div class="item-image-area">
                                                        <img class="item-image" src={(item.image ? item.image.file.url : '')} alt={(item.image ? item.image.description : '')}/>
                                                    </div>
                                                    <div class="item-header">
                                                        <i class="item-header__icon fal fa-book-sparkles"></i>
                                                        <span class="item-header__line"></span>
                                                        <span class="item-header__text">{item.headerText}</span>
                                                    </div>
                                                    <h4 class="item-body">
                                                        {item.text}
                                                    </h4>
                                                    <div class="item-bottom">
                                                        <a class="txr-angle__link" href={item.linkUrl}>Read <i class="txr-angle__link-icon fal fa-angle-right"></i></a>
                                                        <span class="item-bottom__time">{item.minutesToRead} min read</span>
                                                    </div>
                                                </a>
                                            )
                                        }
                                    </div>
                                )}
                            <div class="txr-recommended-section__buttons">
                                <a class="txr-button-link" href="https://help.textrequest.com" target="_blank">
                                    <button class="txr-button txr-action-button txr-black-text txr-width230" type="button">
                                        <span class="txr-button__content">VISIT OUR HELP CENTER<i class="txr-button__angle-icon fal fa-angle-right"></i></span>
                                    </button>
                                </a>
                            </div>
                        </div>
                    }

                    {
                        !this.state.types.allTypes &&
                        <div class="resources-hub__browse txr-section-center">
                            <div class="txr-section__header txr-on-white">
                                BROWSE RESOURCES
                            </div>
                            <div class="txr-section__title">
                                Not finding what you want?
                            </div>
                            <div class="txr-section__text">
                                Try broadening your search with one of these filters.
                            </div>
                            <div class="browse-section__items">

                                <a class="browse-section__item" href="/resources/all">
                                    <div class="browse-section__item-icon">
                                        <i class="browse-section__item-icon-i fal fa-books"></i>
                                    </div>
                                    <div class="browse-section__item-text">VIEW ALL</div>
                                </a>
                                <a class="browse-section__item" href="/resources/case-studies">
                                    <div class="browse-section__item-icon">
                                        <img class="browse-section__item-icon-image" src="/images/resources-hub/icon-case-studies-new.svg" alt="case-study"/>
                                        <img class="browse-section__item-icon-image hover-image" src="/images/resources-hub/icon-case-studies-new-green.svg" alt="case-study"/>
                                    </div>
                                    <div class="browse-section__item-text">CASE STUDIES</div>
                                </a>
                                <a class="browse-section__item" href="/resources/insights">
                                    <div class="browse-section__item-icon">
                                        <img class="browse-section__item-icon-image" src="/images/resources-hub/icon-insights-new.svg" alt="insights"/>
                                        <img class="browse-section__item-icon-image hover-image" src="/images/resources-hub/icon-insights-new-green.svg" alt="insights"/>
                                    </div>
                                    <div class="browse-section__item-text">INSIGHTS</div>
                                </a>

                                <a class="browse-section__item" href="/resources/message-templates">
                                    <div class="browse-section__item-icon">
                                        <i class="browse-section__item-icon-i fal fa-file-heart"></i>
                                    </div>
                                    <div class="browse-section__item-text">TEMPLATES</div>
                                </a>
                                <a class="browse-section__item" href="/resources/playbooks">
                                    <div class="browse-section__item-icon">
                                     <i class="browse-section__item-icon-i fal fa-hand-sparkles"></i>
                                    </div>
                                    <div class="browse-section__item-text">PLAYBOOKS</div>
                                </a>
                                <a class="browse-section__item" href="/resources/ebooks">
                                    <div class="browse-section__item-icon">
                                        <i class="browse-section__item-icon-i fal fa-book-heart"></i>
                                    </div>
                                    <div class="browse-section__item-text">EBOOKS</div>
                                </a>
                                <a class="browse-section__item" href="/resources/newsletters">
                                    <div class="browse-section__item-icon">
                                        <i class="browse-section__item-icon-i fal fa-pencil"></i>
                                    </div>
                                    <div class="browse-section__item-text">NEWSLETTERS</div>
                                </a>

                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default TxrResourcesHub;